import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./app.scss";
import MenuContext from "./MenuContext";
import ApplicationContext from "./ApplicationContext";
import StoreContext from "./StoreContext";
import {
  APPLICATION,
  STORE_NAME_CODE,
  setStore,
} from "./constants";
import { setApplication } from "./constants";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./screens/home/Home";
import Order from "./screens/order/Order";
import OrderComplete from "./screens/order/OrderComplete";
import Account from "./screens/account/Account";
import Admin from "./screens/admin/Admin";
import NotAuthorized from "./screens/admin/NotAuthorized";
import Terms from "./screens/terms/Terms";
import Privacy from "./screens/terms/Privacy";
import Refund from "./screens/terms/Refund";
import Rewards from "./screens/rewards/Rewards";
import GiftCard from "./screens/giftCard/GiftCard";
import AuthenticateModal from "./components/authenticateModal/AuthenticateModal";
import ResetPasswordModal from "./components/authenticateModal/ResetPasswordModal";
import MyOrderPortalHome from "./components/home/MyOrderPortalHome";
import SystemHome from "./components/home/SystemHome";
import { checkIfStoreIsOpen } from "./utils/store/CheckIfStoreIsOpen";
import { checkIfStoreDeliveryIsOpen } from "./utils/store/CheckIfStoreDeliveryIsOpen";
import { getTodaysDate } from "./utils/store/GetTodaysDate";
import { fetchStoreData } from "./utils/store/FetchStoreData";
import { fetchMenuData } from "./utils/store/FetchMenuData";
import { fetchCartData } from "./utils/store/FetchCartData";
import { fetchUserRecentOrders } from "./utils/store/FetchUserRecentOrders";
import LoadingLogo from "./tools/LoadingLogo";

function App() {
  const [applicationNotFound, setApplicationNotFound] = useState();
  const [selectedAddress, setSelectedAddress] = useState();
  const [menuName, setMenuName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [subCategoryName, setSubCategoryName] = useState("");
  const [discountEndDate, setDiscountEndDate] = useState();
  const [detailsAreLoading, setDetailsAreLoading] = useState(true);
  const [authKey, setAuthKey] = useState("Login");
  const [showAuthenticateModal, setShowAuthenticateModal] = useState();
  const [showResetPasswordModal, setShowResetPasswordModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [showItemModal, setShowItemModal] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isClosureToday, setIsClosureToday] = useState(false);
  const [noTopStoreStatusMessage, setNoTopStoreStatusMessage] = useState(false);
  const [userOrders, setUserOrders] = useState();

  const [storeContext, setStoreContext] = useState(
    JSON.parse(localStorage.getItem("storeContext")) || {
      open: null,
      deliveryOpen: null,
      name: null,
      nameCode: null,
      taxPercentage: null,
      chargePercent: null,
      discountPercent: null,
      menuName: null,
      categoryName: null,
      subCategoryName: null,
      hours: null,
      address: null,
      phoneNumber: null,
    }
  );

  const [menuContext, setMenuContext] = useState(
    JSON.parse(localStorage.getItem("menuContext")) || {
      items: null,
      extras: null,
      categories: null,
    }
  );

  const [appContext, setAppContext] = useState(
    JSON.parse(localStorage.getItem("appContext")) || {
      userInfo: null,
      cart: null,
      cartItems: null,
    }
  );

  const toastProps = {
    autoClose: 1250,
    position: "bottom-center",
    icon: false,
    closeButton: false,
    style: {
      width: "90vw",
      fontSize: "1.2rem",
    },
    closeOnClick: false,
  };

  useEffect(() => {
    const pathname = window.location.pathname;
    const store = pathname.split("/")[1];
    setApplication(store);
    const part2 = pathname.split("/")[2];
    if (part2 !== "admin") {
      setNoTopStoreStatusMessage(true);
    }

    //get store and menu data if needed
    if (APPLICATION) {
      const shouldFetchMenu = !menuContext.items || !menuContext.categories;
      const isNotAdminOrOrderOrRewards = part2 !== "admin" && part2 !== "order" && part2 !== "rewards" && part2 !== "account";
      if (shouldFetchMenu || isNotAdminOrOrderOrRewards) {
        fetchMenuData({
          setMenuContext,
          setApplicationNotFound,
        });
      }

      fetchStoreData({
        appContext,
        setAppContext,
        setStoreContext,
        setApplicationNotFound,
        setDetailsAreLoading,
        setMenuName,
        setCategoryName,
        setSubCategoryName,
        setDiscountEndDate,
      });
    } else {
      setApplicationNotFound(true);
    }

    //check if store is open or not
    var isOpen = checkIfStoreIsOpen();
    var isDeliveryOpen = checkIfStoreDeliveryIsOpen();
    var newStore = storeContext;
    newStore.open = isOpen;
    newStore.deliveryOpen = isDeliveryOpen;
    setStore(newStore);
    localStorage.setItem("storeContext", JSON.stringify(newStore));

    //check if today is a store closure
    if (storeContext.storeClosures) {
      const todayDate = getTodaysDate();
      const storeClosures = storeContext.storeClosures.map(
        (closure) => closure.dateClosed
      );
      setIsClosureToday(storeClosures.includes(todayDate));
    }
  }, []);

  useEffect(() => {
    const pathname = window.location.pathname;
    const part2 = pathname.split("/")[2];
    const isAdminOrOrderOrRewards = part2 === "admin" || part2 === "order" || part2 === "rewards" || part2 === "account";

    if (appContext.userInfo && !appContext.cart && !isAdminOrOrderOrRewards) {
      if (
        APPLICATION &&
        (appContext.userInfo.role === "User" ||
          appContext.userInfo.role === "Admin")
      ) {
        fetchCartData({
          appContext,
          setAppContext,
        });
      }
    }

    if (!userOrders && APPLICATION && appContext.userInfo && !isAdminOrOrderOrRewards) {
      fetchUserRecentOrders({
        appContext,
        setAppContext,
        setUserOrders,
      });
    }
  }, [appContext]);

  return (
    <>
      {noTopStoreStatusMessage && (
        <>
          {STORE_NAME_CODE &&
            storeContext.isActive !== "true" &&
            !showAuthenticateModal && (
              <>
                <div className="desktop store_is_not_active fixed-top d-flex justify-content-center">
                  Online ordering temporarily unavailable. Please come back soon and
                  try again.
                </div>
                <div className="mobile store_is_not_active fixed-top d-flex justify-content-center">
                  Online ordering temporarily unavailable. <br /> Please come back
                  soon and try again.
                </div>
              </>
            )}
          {isClosureToday && (
            <>
              <div className="desktop store_is_not_active fixed-top d-flex justify-content-center">
                Sorry we are closed for the day. Please come back tomorrrow and try
                again.
              </div>
              <div className="mobile store_is_not_active fixed-top d-flex justify-content-center">
                Sorry we are closed for the day. <br /> Please come back tomorrrow
                and try again.
              </div>
            </>
          )}
          {storeContext.open === "Closed" && !isClosureToday && (
            <>
              <div className="desktop store_is_not_active fixed-top d-flex justify-content-center">
                {storeContext.acceptDelivery === "true" ? (
                  <>
                    We are closed right now, but you can order for later. Choose a pickup or delivery time at checkout.
                  </>
                ) : (
                  <>
                    We are closed right now, but you can order for later. Choose a pickup time at checkout.
                  </>
                )}
              </div>
              <div className="mobile store_is_not_active fixed-top d-flex justify-content-center">
                {storeContext.acceptDelivery === "true" ? (
                  <>
                    We are closed right now, but you can order for later. Choose a pickup or delivery time at checkout.
                  </>
                ) : (
                  <>
                    We are closed right now, but you can order for later. Choose a pickup time at checkout.
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
      {showAuthenticateModal && (
        <AuthenticateModal
          appContext={appContext}
          storeContext={storeContext}
          showAuthenticateModal={showAuthenticateModal}
          setShowAuthenticateModal={setShowAuthenticateModal}
          showResetPasswordModal={showResetPasswordModal}
          setShowResetPasswordModal={setShowResetPasswordModal}
          authKey={authKey}
          setAuthKey={setAuthKey}
          setAppContext={setAppContext}
        />
      )}
      {showResetPasswordModal && (
        <ResetPasswordModal
          appContext={appContext}
          storeContext={storeContext}
          showResetPasswordModal={showResetPasswordModal}
          setShowResetPasswordModal={setShowResetPasswordModal}
          setAppContext={setAppContext}
        />
      )}

      {applicationNotFound ? (
        // <SystemHome />
        <MyOrderPortalHome />
      ) : (
        <>
          {detailsAreLoading ? (
            <div className="loading_details" id="loading_details">
              <LoadingLogo />
            </div>
          ) : (
            <StoreContext.Provider value={storeContext}>
              <ApplicationContext.Provider value={appContext}>
                <MenuContext.Provider value={menuContext}>
                  <div className="app">
                    <ToastContainer
                      position="bottom-center"
                      limit={1}
                      {...toastProps}
                    />
                    <BrowserRouter>
                      <Routes>
                        <Route path="/our_stores" element={<SystemHome />} />
                        <Route
                          path="/:storeParam"
                          element={
                            <Home
                              showItemModal={showItemModal}
                              setShowItemModal={setShowItemModal}
                              selectedItem={selectedItem}
                              setSelectedItem={setSelectedItem}
                              detailsAreLoading={detailsAreLoading}
                              menuName={menuName}
                              setMenuName={setMenuName}
                              categoryName={categoryName}
                              setCategoryName={setCategoryName}
                              subCategoryName={subCategoryName}
                              setSubCategoryName={setSubCategoryName}
                              discountEndDate={discountEndDate}
                              setAppContext={setAppContext}
                              authKey={authKey}
                              setAuthKey={setAuthKey}
                              showAuthenticateModal={showAuthenticateModal}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                              cartOpen={cartOpen}
                              setCartOpen={setCartOpen}
                              isDisabled={isDisabled}
                              setIsDisabled={setIsDisabled}
                              userOrders={userOrders}
                              setUserOrders={setUserOrders}
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/terms"
                          element={
                            <Terms
                              authKey={authKey}
                              setAuthKey={setAuthKey}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                              setAppContext={setAppContext}
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/privacy"
                          element={
                            <Privacy
                              authKey={authKey}
                              setAuthKey={setAuthKey}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                              setAppContext={setAppContext}
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/refund"
                          element={
                            <Refund
                              authKey={authKey}
                              setAuthKey={setAuthKey}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                              setAppContext={setAppContext}
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/giftCards"
                          element={
                            <GiftCard
                              authKey={authKey}
                              setAuthKey={setAuthKey}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                              setAppContext={setAppContext}
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/order"
                          element={
                            <Order
                              setAuthKey={setAuthKey}
                              setAppContext={setAppContext}
                              selectedAddress={selectedAddress}
                              setSelectedAddress={setSelectedAddress}
                              discountEndDate={discountEndDate}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/completion"
                          element={
                            <OrderComplete
                              setAuthKey={setAuthKey}
                              setAppContext={setAppContext}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/account"
                          element={
                            <Account
                              setAuthKey={setAuthKey}
                              setAppContext={setAppContext}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                            />
                          }
                        />
                        <Route
                          path="/:storeParam/rewards"
                          element={
                            <Rewards
                              isDisabled={isDisabled}
                              setIsDisabled={setIsDisabled}
                              showItemModal={showItemModal}
                              setShowItemModal={setShowItemModal}
                              selectedItem={selectedItem}
                              setSelectedItem={setSelectedItem}
                              setAuthKey={setAuthKey}
                              setAppContext={setAppContext}
                              setShowAuthenticateModal={
                                setShowAuthenticateModal
                              }
                              cartOpen={cartOpen}
                              setCartOpen={setCartOpen}
                              detailsAreLoading={detailsAreLoading}
                            />
                          }
                        />
                        {appContext.userInfo &&
                          appContext.userInfo.role === "Admin" ? (
                          <>
                            <Route
                              path="/:storeParam/admin"
                              element={
                                <Admin
                                  setAuthKey={setAuthKey}
                                  menuContext={menuContext}
                                  setAppContext={setAppContext}
                                  setStoreContext={setStoreContext}
                                  setShowAuthenticateModal={
                                    setShowAuthenticateModal
                                  }
                                />
                              }
                            />
                          </>
                        ) : (
                          <>
                            <Route
                              path="/:storeParam/admin"
                              element={
                                <NotAuthorized
                                  setAuthKey={setAuthKey}
                                  setAppContext={setAppContext}
                                  setShowAuthenticateModal={
                                    setShowAuthenticateModal
                                  }
                                />
                              }
                            />
                          </>
                        )}
                      </Routes>
                    </BrowserRouter>
                  </div>
                </MenuContext.Provider>
              </ApplicationContext.Provider>
            </StoreContext.Provider>
          )}
        </>
      )}
    </>
  );
}

export default App;
